module.exports = __webpack_public_path__ + "img/NZ.7d1ea3d5.svg";